<template>
<div>
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper">
        <h6 class="element-header">{{ t('blacklistedUsersTitle', 'blacklistedUsersTitle')}}</h6>
        <div class="element-box">
          <div class="element-info">
            <div class="row align-items-center">
              <div class="col-sm-8">
                <div class="element-info-with-icon">
                  <div class="element-info-icon">
                    <div class="os-icon os-icon-users">
                    </div>
                  </div>
                  <div class="element-info-text">
                    <h5 class="element-inner-header">{{ t('blacklistedUsersHeader', 'blacklistedUsersHeader')}}</h5>
                    <div class="element-inner-desc">{{ t('blacklistedUsersDesc','blacklistedUsersDesc') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="input-group col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
              <b-input-group class="form-group col-lg-12 px-0">
                <b-input-group-prepend>
                  <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                </b-input-group-prepend>
                <b-form-select v-model="perPage" @change="getBlacklistedUsers()" :options="pageOptions"></b-form-select>
              </b-input-group>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-12 mb-2 mb-md-0">
              <b-input-group class="form-group col-lg-12 px-0">
                  <b-form-input v-model="searchedEmail" :placeholder="t('searchedBlacklistEmailPlaceholder', 'searchedBlacklistEmailPlaceholder')"></b-form-input>
                  <b-input-group-append>
                      <b-button variant="primary" @click.prevent="getBlacklistedUsers()">{{ t('searchBtnText','searchBtnText') }}</b-button>
                  </b-input-group-append>
              </b-input-group>
            </div>
            <div class="col-lg-7 col-md-4 col-sm-12 mb-2 mb-md-0 text-right">
              <button class="btn btn-primary" :disabled="selectedUsers.length < 1" @click="showBlacklistModal()">{{ t('requestBlacklistRemovalBtnText', 'requestBlacklistRemovalBtnText') }}</button>
            </div>
          </div>
          <div class="row">
            <div class="offset-md-8 col-md-4 offset-lg-8 col-lg-4 mb-2 mb-md-0">
              <b-pagination class="float-right mb-0" v-model="currentPage" :per-page="perPage" aria-controls="blacklistusers-table" v-if="blacklistedUsers.length > 0"></b-pagination>
            </div>
          </div>
          <hr>
          <ResponseInfo class='px-0 mx-0' v-if="getResponseInfo.responseName == 'blacklistRemoval'"></ResponseInfo>
          <b-table v-if="blacklistedUsers" id="blacklistusers-table" striped hover bordered :fields="fields" :show-empty="rowEmpty" :items="blacklistedUsers" :busy.sync="isBusy" :per-page="perPage" :currentPage="currentPage" :filter="filter" @filtered="onFiltered">
            <template class="busy-row" v-slot:table-busy>
              <vcl-table :rows="parseInt(perPage)" :columns="3"></vcl-table>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
            </template>
            <template v-slot:head(blacklistCheckbox)="data">
              <span></span>
            </template>
            <template v-slot:head(blacklistEmail)="data">
              <span>{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:head(blacklistDetails)="data">
              <span>{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:cell(blacklistCheckbox)="data">
              <div class="col-12 text-center flex-center">
                <b-form-checkbox
                  :id="'checkbox-' + data.item.email"
                  @change="handleBlacklistCheckbox($event, data.item.email)"
                  :name="'checkbox-' + data.item.email"
                  value="selected"
                  unchecked-value="unselected"
                  align="center"
                  :disabled="data.item.disable_request"
                ></b-form-checkbox>
              </div>
            </template>
            <template v-slot:cell(blacklistEmail)="data">
              <span>{{ data.item.email }}</span>
            </template>
            <template v-slot:cell(blacklistDetails)="data">
              <div class="col-12 text-left"><b>{{ t('blacklistReasonLabel', 'blacklistReasonLabel') }}</b>: {{ data.item.reason }}</div>
              <div class="col-12 text-left"><b>{{ t('blacklistDetailLabel', 'blacklistDetailLabel') }}</b>: 
                <span v-if="data.item.detail">{{ data.item.detail }}</span>
                <span v-else>{{ t('blacklistNoDetailsAvailableText', 'blacklistNoDetailsAvailableText') }}</span>
              </div>
              <div class="col-12 text-left"><b>{{ t('blacklistLastUpdateLabel', 'blacklistLastUpdateLabel') }}</b>: {{ data.item.last_event_at }}</div>
              <div class="col-12 text-left"><b>{{ t('blacklistExipresAtLabel', 'blacklistExipresAtLabel') }}</b>: {{ data.item.expires_at }}</div>
              <div class="col-12 text-left text-red" v-if="data.item.disable_request">{{ t('blacklistRemovalRequestAlreadySent', 'blacklistRemovalRequestAlreadySent') }}</div>
            </template>
          </b-table>
          <div class="row">
            <div class="offset-md-8 col-md-4 offset-lg-8 col-lg-4 mb-2 mb-md-0">
              <b-pagination class="float-right mb-0" v-model="currentPage" :per-page="perPage" aria-controls="blacklistusers-table" v-if="blacklistedUsers.length > 0"></b-pagination>
            </div>
          </div>
        </div>
        <ModalSendBlacklistRemovalRequest :modalData="this.modalData" />
        <div v-if="Object.keys(modalData).length !== 0" class="modal-backdrop show"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import { mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ModalSendBlacklistRemovalRequest from '@/components/Users/ModalSendBlacklistRemovalRequest.vue'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VclTable } from 'vue-content-loading'

export default {
    name: 'BlacklistUsers',
    components:{
        VclTable,
        ModalSendBlacklistRemovalRequest,
        ResponseInfo
    },
    data () {
      return {
          fields: [
              {key: 'blacklistCheckbox', label:'', sortable: false, thClass: 'hover-pointer brand-color width-small'},
              {key: 'blacklistEmail', label: 'blacklistEmail', sortable: false, thClass: 'hover-pointer brand-color width-small'},
              {key: 'blacklistDetails', label: 'blacklistDetails', sortable: false, thClass: 'hover-pointer brand-color width-small'}
          ],
          currentPage: 1,
          perPage: 20,
          pageOptions: [10, 20, 50, 100],
          filter: null,
          isBusy: true,
          rowEmpty: true,
          blacklistedUsers: [],
          selectedUsers: [],
          modalData: {},
          searchedEmail: null,
          totalRows: 0,
          filteredRows: '',
      }
    },
    methods: {
      onFiltered(filteredItems) {
          this.filteredRows = filteredItems.length
          this.currentPage = 1
      },
      getBlacklistedUsers() {
        this.isBusy = true

        this.$router.replace({'query': null});
        this.$router.push({ query: { ...this.$route.query, page: this.currentPage, per_page: this.perPage } })

        if(this.searchedEmail) {
          this.$router.push({ query: { ...this.$route.query, email: this.searchedEmail }})
        }

        this.$store.dispatch('getBlacklistedUsers', {
          currentPage: this.currentPage,
          perPage: this.perPage,
          searchedEmail: this.searchedEmail
        }).then(response => {
          this.isBusy = false
          this.blacklistedUsers = response.blacklistedUsers
          this.totalRows = response.blacklistedUsers.length

          if(response.blacklistedUsers.length > 0) {
            this.rowEmpty = false
          } else {
            this.rowEmpty = true
          }
        })

      },
      handleBlacklistCheckbox(event, email) {
        if(event == 'selected') {
          this.selectedUsers.push(email)
        } else if(event == 'unselected') {
          const index = this.selectedUsers.indexOf(email);
          if (index > -1) {
            this.selectedUsers.splice(index, 1);
          }
        }
      },

      showBlacklistModal() {
        this.modalData.userEmails = this.selectedUsers
        this.modalData.id = 'modalSendBlacklistRemovalRequest'
        this.$root.$emit('bv::show::modal', this.modalData.id)
      }
    },
    computed:{
        ...mapGetters(['getUserDetails', 'getUserLevel', 'getResponseInfo']),
        datePickerFormat() {
          if(this.$store.getters.allTemplateDetails.datePickerFormat) {
            let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, ' ')
            return dateformat
          }
        }
    },
    created() {
        this.getBlacklistedUsers()
    },
    filters:{
        formatDate: function(date) {
          return moment(date).fromNow(true);
        },
        humanReadable: function(date) {
          return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        },
        clientDateFormatter: function(date, datePickerFormat) {
          return moment(date).format(datePickerFormat + ' h:mm:ss')
        }
    }
}

</script>

<style scoped>
  table >>> tbody, table >>> thead{
    text-align: center;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  div.table-responsive >>> table th.width-small{
    padding: 12px !important;
    width: 100%;
    min-width: 80px !important;
    max-width: 80px !important;
    max-width: 100px;
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .text-red {
    color: red;
  }
</style>
